export function ordenarRegistros<T>(array: T[], chave: keyof T): T[] {
  return array.sort((a, b) => {
    if (a[chave] < b[chave]) return -1;
    if (a[chave] > b[chave]) return 1;
    return 0;
  });
}
